import { RefObject, useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import Player from '@vimeo/player';

import { UploadedFileVideo } from '@/component/FileUpload/types';

export const useVimeoPlayer = ({
  uploadedFileVideo,
}: {
  uploadedFileVideo: UploadedFileVideo;
}): {
  playerElementId: string;
  videoRef: RefObject<HTMLDivElement>;
  localRatio: number;
} => {
  const [localRatio, setLocalRatio] = useState(uploadedFileVideo.ratio || 0.5625);
  const [playerElementId] = useState(`vimeo-${uuid()}`);
  const videoRef = useRef<HTMLDivElement>(null);
  const [, setVimeoPlayer] = useState<Player>();

  const createPlayer = () => {
    if (uploadedFileVideo?.vimeoId && videoRef.current) {
      return new Player(videoRef.current, {
        id: parseInt(uploadedFileVideo?.vimeoId),
        width: 800,
        height: 450,
        speed: true,
      });
    }

    return null;
  };

  useEffect(() => {
    const player = createPlayer();

    if (player) {
      setVimeoPlayer(player);

      if (uploadedFileVideo?.ratio) {
        Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(([width, height]) => {
          setLocalRatio(height / width);
        });
      }
    }
  }, [uploadedFileVideo]);

  return {
    playerElementId,
    videoRef,
    localRatio,
  };
};
